import { render, staticRenderFns } from "./OrderItemDetails.vue?vue&type=template&id=447c9bfc"
import script from "./OrderItemDetails.vue?vue&type=script&lang=js"
export * from "./OrderItemDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports